import React from 'react';
import { Eye } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { ProofThumbnail } from '../../components/ProofThumbnail';

const STATUS_BADGE_CLASS = {
  completed: 'bg-green-100 text-green-800',
  proof_approved: 'bg-blue-100 text-blue-800',
  proof_pending: 'bg-yellow-100 text-yellow-800',
  proof_rejected: 'bg-red-100 text-red-800',
};

export const OrdersTable = ({ orders, loading, onManageOrder }) => (
  <div className="bg-white rounded-lg shadow-lg p-8" data-testid="admin-orders-panel">
    <h2 className="text-2xl font-bold text-gray-800 mb-6">Enhanced Order Management</h2>
    {loading ? (
      <p className="text-center py-12 text-gray-500">Loading orders...</p>
    ) : orders.length === 0 ? (
      <p className="text-center py-12 text-gray-500">No orders found</p>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="px-3 py-3 text-left text-sm font-semibold text-gray-700 w-20">Preview</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Order #</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Customer Email</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Items</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Total</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Status</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Date</th>
              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="border-b hover:bg-gray-50">
                <td className="px-3 py-2">
                  {/* iter114s.74 — admin at-a-glance preview. Lazy-
                      loads via IntersectionObserver so a 200-row
                      table doesn't render-bomb the artwork
                      rasteriser. Clicking the thumbnail opens the
                      management modal so admins can jump straight
                      from visual recognition to the order detail. */}
                  <button
                    type="button"
                    onClick={() => onManageOrder(order)}
                    className="block rounded-md focus:outline-none focus:ring-2 focus:ring-[#6FBF73]/60 hover:opacity-90 transition"
                    aria-label={`Open management modal for order ${order.order_number}`}
                    data-testid={`admin-order-row-thumbnail-${order.id}`}
                  >
                    <ProofThumbnail
                      orderId={order.id}
                      size={52}
                      rounded="md"
                      alt={`Proof preview for ${order.order_number}`}
                    />
                  </button>
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 font-medium">{order.order_number}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{order.customer_email || 'N/A'}</td>
                <td className="px-4 py-3 text-sm text-gray-600">{order.items?.length || 0}</td>
                <td className="px-4 py-3 text-sm text-gray-900 font-semibold">
                  ${order.total_price?.toFixed(2) || '0.00'}
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`px-2 py-1 text-xs rounded-full ${
                      STATUS_BADGE_CLASS[order.status] || 'bg-gray-100 text-gray-800'
                    }`}
                  >
                    {order.status?.replace('_', ' ').toUpperCase()}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  {order.created_at ? new Date(order.created_at).toLocaleDateString() : 'N/A'}
                </td>
                <td className="px-4 py-3 text-center">
                  <Button
                    onClick={() => onManageOrder(order)}
                    className="bg-[#4A7C59] hover:bg-[#3d6849] text-white text-xs px-3 py-1"
                    data-testid={`admin-manage-order-${order.id}`}
                  >
                    <Eye className="w-4 h-4 inline mr-1" />
                    Manage
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
